// extracted by css-extract-rspack-plugin
export default {"item":"item-tKZ3lP","itemLabel":"itemLabel-FtziIi text-base-regular","itemValue":"itemValue-OHn4Ae text-base-semibold"};